/*
  Перечисления для измерений
*/

/*
Тип измерения
*/

export enum MeasurementType {
  //Сигнал
  Signal = 1,

  //Спектр
  Spectrum = 2,

  //Сырой сигнал
  Raw = 3,
}
